import { PropsWithChildren } from "react";
import "./style.css";

export const RichTextContainer = ({ children }: PropsWithChildren<{}>) => {
  return <div className="rich-text-container">{children}</div>;
};

export default RichTextContainer;
